module.exports = __webpack_public_path__ + "static/media/profile_psed.b4854830.jpg";